import React from 'react';
import LandingPageLayout from 'components/LandingPageLayout';
import WrapHeadingSection from 'components/v1-tailwindcss/WrapHeadingSection';
import PeaceOfMind from 'components/v1-tailwindcss/PeaceOfMind';
import Head from 'next/head';
import RentalMontReal from 'components/v1-tailwindcss/RentalMontReal';


const RentInToronto = () => {
  
  return (
    <>
      <Head>
        <meta charset="utf-8" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/tailwindcss/2.2.19/tailwind.min.css"></link>
        <title>Condos, Townhouses, Apartments and furnished rooms for rent in Toronto</title>
        <meta name="author" content="SoulRooms" />
        <meta property="og:site_name" content="SoulRooms" />
        <meta property="og:title" content="Condos, Townhouses, Apartments and furnished rooms for rent in Toronto" />
        <meta
          property="og:description"
          content="Choose from over 2000 apartments, houses, condos and furnished rooms for rent in Toronto. "
        />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://img1.wsimg.com/isteam/videos/naBxa52" />
        <meta property="og:locale" content="en_US" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@soulroomsTO" />
        <meta name="twitter:title" content="Condos, Townhouses, Apartments and furnished rooms for rent in Toronto" />
        <meta
          name="twitter:description"
          content="Choose from over 2000 apartments, houses, condos and furnished rooms for rent in Toronto. "
        />
        <meta name="twitter:image" content="https://img1.wsimg.com/isteam/videos/naBxa52" />
        <meta name="twitter:image:alt" content="SoulRooms" />
        <meta name="theme-color" content="#FCBD00" />
      </Head>
      <LandingPageLayout>
        <div className="container mx-auto">
          <RentalMontReal
            link="#JotFormIFrame-91797058303261"
            imgSrc="/static/images/landingPages/RentInToronto/caat.webp"
            title="Rentals in Toronto"
            para1="High-rise condos with a view, spacious townhouses with a backyard or furnished rooms on flexible terms,
            find housing options that perfectly suit your needs, curated from the best landlords in the city. "
            btn_text="Find Properties"
            locNone="hidden"
          />

          <WrapHeadingSection headTitle="LIVE, GROW AND HAVE THE BEST TIME WHILE YOU ARE AT IT">
            <div className="pb-12">
              <PeaceOfMind
                imgSrc="/static/images/landingPages/RentInToronto/toronto1.webp"
                title="Great Lifestyle"
                para="With over 400 properties to choose from across some of the most coveted neighbourhoods in the city, you are sure to be spoilt for choice. "
              />
            </div>
            <div className="pb-12">
              <PeaceOfMind
                imgSrc="/static/images/landingPages/RentInToronto/toronto2.webp"
                title="Trusted Landlords"
                para="All curated properties belong to a highly reputable set of landlords ensuring you are served by the best in the business."
                order3="2"
                order4="1"
              />
            </div>
            <div className="pb-12">
              <PeaceOfMind
                imgSrc="/static/images/landingPages/RentInToronto/toronto3.webp"
                title="Right people, Right Stay"
                para="With an array of studios, one, two and three-bedroom options available, there is something on offer for everyone."
              />
            </div>
          </WrapHeadingSection>
          <WrapHeadingSection headTitle="FILL IN YOUR REQUIREMENTS & SEE AVAILABLE OPTIONS">
            <iframe
              id="JotFormIFrame-91797058303261"
              title="Find a SoulRoom"
              onload="window.parent.scrollTo(0,0)"
              allowtransparency="true"
              allowfullscreen="true"
              allow="geolocation; microphone; camera"
              src="https://form.jotform.com/91797058303261"
              frameborder="0"
              style={{ minWidth: '100%', height: '640px', border: 'none', scrolling: 'no' }}></iframe>
          </WrapHeadingSection>
        </div>
      </LandingPageLayout>
    </>
  );
};

export default RentInToronto;
